import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import LocationImage from '/icons/location.svg'

export default function Location () {
  const { t: ti } = useTranslation('info')

  return (
    <div className={styles.root}>
      <div className={styles.root__content}>
        <h3 className={styles.root__title}>{ti('location.title')}</h3>
        <p className={styles.root__desc}>{ti('location.description')}</p>
        {/* <Button theme="white" size="large">
          {ti("location.button")}
        </Button> */}
        {/* // временно скрыто */}

        <img className={styles.root__image} src={LocationImage} alt="" />
      </div>
    </div>
  )
}
